import { render, staticRenderFns } from "./examinationConfig.vue?vue&type=template&id=316bd64c&scoped=true"
import script from "./examinationConfig.vue?vue&type=script&lang=js"
export * from "./examinationConfig.vue?vue&type=script&lang=js"
import style0 from "./examinationConfig.vue?vue&type=style&index=0&id=316bd64c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316bd64c",
  null
  
)

export default component.exports